import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavService {
  private activeNavItem = new BehaviorSubject('start')
  public currentActiveNavItem = this.activeNavItem.asObservable()

  private hideNav = new BehaviorSubject(false)
  public triggerNavHide = this.hideNav.asObservable()

  constructor() { }

  changeActiveNavItem(itemSlug: string) {
    this.activeNavItem.next(itemSlug)
  }

  changeNavVisibility(v) {
    console.log('Change Nav fom service ', v);
    
    this.hideNav = v
  }

}
